// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-48976ce4] .consent a{--text-opacity:1;color:#4372c8;color:rgba(67,114,200,var(--text-opacity))}[data-v-48976ce4] .consent a:hover{hover:text-primary-normal-blue}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
